import BadgeStyle from '@/components/style/badge-style';

const PRODUCT_IMAGE_DEFAULT =
  'https://cdn.shopify.com/s/files/1/0688/9960/2752/files/FoB_Pro_Curly_Hair_Shampoo_ecom.png?v=1695914413';

const RetailProductItem = ({ productData, isSmall, productTitleTransform }) => {
  const bestSellerTag = productData?.tags?.find((t) =>
    t.includes('bestseller')
  );

  const variantId = productData?.variants?.edges[0]?.node?.id;
  const variantIdFormated = variantId.substring(variantId.lastIndexOf('/') + 1);

  console.log('==== productData', productData);

  const productImage = productData?.featuredImage?.url || PRODUCT_IMAGE_DEFAULT;

  const price = Number(
    productData?.priceRange?.maxVariantPrice?.amount ?? 0
  ).toFixed(2);

  const ctaText = productData?.availableForSale ? 'shop now' : 'sold out';

  return `
    <product-card
      handle="${productData.handle}"
      title="${productData.title}"
      url="/products/${productData.handle}"
      image-url="${productImage}"
      image-alt="${productData.title}"
      price-label="From"
      price="${price}"
      cta-prefix="shop"
      cta-suffix="now"
      cta-disabled="${!productData.availableForSale}"
      cta-bg-color="transparent"
      badge="${bestSellerTag ? 'Best seller' : ''}"
      data-redirect-mode="true"
    >
    </product-card>
            `;
};

export default RetailProductItem;
